import { flattenLeaves, FlattenedLeaf } from "./flattenLeaves"
import { matchPath } from "./matchPath"
import { NavNode } from "./navigation.types"

export interface ActiveNavSelection {
  selectedId: string | null
  parentId: string | null
}

const EMPTY: ActiveNavSelection = { selectedId: null, parentId: null }

const longerPath = (a: FlattenedLeaf, b: FlattenedLeaf): FlattenedLeaf =>
  b.path.length > a.path.length ? b : a

export function findActiveNavItem(nodes: NavNode[], pathname: string): ActiveNavSelection {
  const matches = flattenLeaves(nodes).filter((leaf) => matchPath(leaf.path, pathname))

  if (matches.length === 0) return EMPTY

  const best = matches.reduce(longerPath)
  return { selectedId: best.id, parentId: best.parentId }
}
